/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(3);
	
	var devicePixelRatio = window.devicePixelRatio;
	
	if (devicePixelRatio > 1) {
	    $('#mlist').remove();
	    $('#mlist2x').show().linkMore({ num: 15 });
	} else {
	    $('#mlist2x').remove();
	    $('#mlist').show().linkMore({ num: 15 });
	}

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = LinkMore;
	/**
	 * @requires jQuery
	 * @author Ei
	 */
	/**
	 * @param  {string}   elmSelector 元素选择器
	 * @param  {hash} options       {
	 *                                num {number} 每次加载的个数
	 *                                btn {string} 按钮选择器
	 *                                callBack{function} 加载前的回调函数
	 *                              }
	 * @constructor
	 */
	function LinkMore(elmSelector) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var $items = $(elmSelector).children('.item'),
	      _options$btn = options.btn,
	      btn = _options$btn === undefined ? '.mbtn' : _options$btn,
	      _options$num = options.num,
	      num = _options$num === undefined ? 0 : _options$num,
	      callBack = options.callBack,
	      $btn = $(btn),
	      mark = 0;
	
	  callBack = typeof callBack === 'function' ? callBack : function () {};
	
	  function init() {
	    linkMore();
	    $btn.on('click', function () {
	      linkMore();
	    });
	  }
	
	  function linkMore() {
	    var length = $items.length,
	        start = mark;
	    mark += num;
	    var $targets = $items.slice(start, mark);
	
	    if (length - mark <= 0) {
	      if ($btn.fadeOut) {
	        $btn.fadeOut('slow');
	      } else {
	        $btn.hide();
	      }
	    }
	
	    if (length - start <= 0) {
	      return;
	    }
	
	    callBack($items, start, num);
	    $targets.addClass('active');
	  }
	
	  init();
	}
	var DATA_KEY = 'linkMore';
	if (window.jQuery || window.Zepto) {
	  (function ($) {
	    'use strict';
	
	    $.fn.linkMore = function (params) {
	      var firstInstance = void 0;
	      this.each(function (i) {
	        var data = $(this).data(DATA_KEY);
	        if (!data) {
	          data = new LinkMore(this, params);
	          $(this).data(DATA_KEY, data);
	        }
	        if (!i) firstInstance = data;
	      });
	      return firstInstance;
	    };
	  })(window.jQuery || window.Zepto);
	}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// cooperators.js